<template>
  <div>
    <div class="mb-2 p-4">
      <icon-view
        icon="fas fa-user-plus text-orange"
        title="Asignar"
        variant="custom-icon-view"
        icon-background="white"
      />
      <div class="row my-3">
        <div class="col-md-4 col-12">
          <div class="form-group">
            <div class="d-flex flex-row justify-content-between">
              <div class="w-75">
                <custom-input
                  v-model="sie"
                  type="number"
                  class="w-100"
                  label="SIE del Estudiante:"
                  placeholder="Escriba Número de SIE"
                  icon="fas fa-search text-orange"
                  left-icon
                />
              </div>
              <div class="d-flex align-items-end justify-content-end">
                <action-button
                  id="btnSave"
                  i="fas fa-file-plus"
                  text="Añadir"
                  :variant="
                    canAddStudent && !loadingStudent ? 'success' : 'secondary'
                  "
                  :disabled="loadingStudent || !canAddStudent"
                  @click="addStudent"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasStudentsSelected">
        <icon-view
          :title="studentSelectedTitle"
          icon="fas fa-user text-white"
          variant="custom-icon-view-2"
        />
        <div class="px-3 py-2">
          <div v-for="(student, key) in model.students" :key="key">
            <div
              class="row font-weight-normal p-3 bg-white rounded border-left-4 my-2"
            >
              <div class="col-md-3 col-12">
                <div class="color-secondary-6 font-14">
                  Nombre del Estudiante:
                </div>
                <div class="color-black font-16 text-break">
                  {{ student.fullName | empty }}
                </div>
              </div>
              <div class="col-md col-12">
                <div class="color-secondary-6 font-14">
                  SIE:
                </div>
                <div class="color-black font-16 text-break">
                  {{ student.studentId | empty }}
                </div>
              </div>
              <div class="col-md col-12">
                <div class="color-secondary-6 font-14">
                  Edad:
                </div>
                <div class="color-black font-16 text-break">
                  {{ `${student.age}`.split(".")[0] | empty }}
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="color-secondary-6 font-14">
                  Impedimento:
                </div>
                <div class="color-black font-16 text-break">
                  {{ student.impediment | empty }}
                </div>
              </div>
              <div class="col-md col-12">
                <div class="color-secondary-6 font-14">
                  Estatus:
                </div>
                <div class="color-black font-16 text-break">
                  {{ student.status | empty }}
                </div>
              </div>
              <div
                class="col-md-1 col-12 d-flex align-items-center justify-content-end"
              >
                <action-button
                  i="fas fa-times-circle"
                  variant="outline-danger"
                  @click="quitStudent(key)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <custom-text-area
          show-char-count
          v-model="model.comment"
          placeholder="Escribe un comentario"
          label="Comentario:"
          custom-error-msg="Este campo es requerido"
          :count-classes="['d-block text-right']"
          :maxlength="3000"
        />
      </div>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 px-3"
          @click="cancel"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success px-3"
          @click="save"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomInput from "CustomInput";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import studentApi from "@/services/student.js";
import StudentStatuses from "@/utils/constants/student/studentStatuses.js";
import resourcesService from "@/services/resources.js";

export default {
  name: "AssignStudentBook",
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomInput
  },
  mixins: [alertMixin],
  data() {
    return {
      sie: null,
      loadingStudent: false,
      model: {
        comment: null,
        students: []
      },
      resources: []
    };
  },
  computed: {
    hasStudentsSelected() {
      return this.model.students.length > 0;
    },
    studentSelectedTitle() {
      return this.model.students.length > 1
        ? "Estudiantes Seleccionados"
        : "Estudiante Seleccionado";
    },
    canAddStudent() {
      const validSie =
        this.sie?.length === 8 && Number.isInteger(Number(this.sie));

      const validRules = [validSie, !this.hasStudentsSelected];
      return validRules.every(x => x);
    },
    firstSie() {
      return this.model.students.map(x => x.studentId)[0];
    }
  },
  async created() {
    await this.loadResources();
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(["44"]);
    },
    quitStudent(index) {
      this.model.students.splice(index, 1);
    },
    async addStudent() {
      if (!this.canAddStudent) return;

      if (this.model.students.some(x => x.studentId === this.sie)) {
        this.ShowToast(
          "Error",
          "El estudiante se encuentra registrado.",
          "error"
        );
        return;
      }
      this.loadingStudent = true;

      try {
        const { data } = await studentApi.getBySie(this.sie);

        if (!data.canAccess) throw new Error(this.resources["44"]);

        if (data.statusId !== StudentStatuses.Servido)
          throw new Error("El estudiante debe estar en el estatus de Servido.");

        this.model.students.push(data);
        this.sie = null;
        this.loadingStudent = false;
      } catch (error) {
        this.ShowToast(
          "Error",
          error?.message ?? error?.response?.data?.message,
          "error"
        );
        this.loadingStudent = false;
        throw error;
      }
    },
    cancel() {
      this.$emit("close");
    },
    async save() {
      if (!this.hasStudentsSelected) {
        this.ShowToast(
          "Error",
          "Es requerido que seleccione un estudiante.",
          "error"
        );
        return;
      }
      const confirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!confirmed) return;

      const payload = {
        sie: this.firstSie,
        comment: this.model.comment
      };

      this.$emit("save", payload);
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .custom-icon-view > .dot,
::v-deep .custom-icon-view-2 > .dot {
  padding: 15px;
  margin: 0px 5px 0px 0px;
}
::v-deep .custom-icon-view-2 > .dot {
  background: #ff7058 !important;
}
.border-left-4 {
  border-left: 4px solid #b5c3bc !important;
}
</style>
